import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useContext } from "react";
import { AuthContext } from "../../../context/authContext";
import { getAllHistory } from "./api";
import { useQuery } from "@tanstack/react-query";
import { allHistoryColumns } from "./columns";

import TableView from "./TableView";

const AllTasksPage = () => {
  const { accessToken } = useContext(AuthContext);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    isSuccess,
    isLoading,
    isError,
    data: allHistory,
  } = useQuery({
    queryKey: ["history_all"],
    queryFn: () => getAllHistory({ accessToken }),
  });
  if (isSuccess) {
    // console.log({ allTasks })
  }

  return (
    <Box sx={{ display: "flex", alignItems: "start" }}>
      <Box sx={{ m: 4, width: "100%", pr: 3 }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" fontSize={"1.5rem"} color="secondary">
            All Videos History
          </Typography>

          {isSuccess && (
            <TableView columns={allHistoryColumns} data={allHistory} />
          )}
          <div></div>
        </div>
      </Box>
    </Box>
  );
};

export default AllTasksPage;
